import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { CaseIdentifier } from './../shared/case-identifier';
import { CaseViewService } from './case-view.service';
import { CivilSearchService } from './../civil/civil-search.service';
import { JuvenileSearchService } from './../juvenile/juvenile-search.service';
import { CourtCase } from '../shared/court-case';

import { JuvenileCase } from '../juvenile/juvenile-case';

@Component({
  selector: 'app-case-view',
  templateUrl: './case-view.component.html',
  styleUrls: ['./case-view.component.less']
})
export class CaseViewComponent implements OnDestroy, OnInit {

  selectedCase: CourtCase;
  errors: any[] = [];
  requestSubscription: Subscription;

  constructor(private caseViewService: CaseViewService,
              private civilSearchService: CivilSearchService,
              private juvenileSearchService: JuvenileSearchService,
              private route: ActivatedRoute
              ) { }

   ngOnInit() {
    const caseIdentifier
      = new CaseIdentifier(this.route.snapshot.params['type'],
                           this.route.snapshot.params['county'],
                           this.route.snapshot.params['casenumber']);
     this.loadCase(caseIdentifier);
   }

  ngOnDestroy() {
    this.cancelAnyOutstandingRequest();
    this.caseViewService.setSelectedCase(null);
  }

  loadCase(caseIdentifier: CaseIdentifier): void {
    let loadedCase: any;
     // alert("YYYY");
    switch (caseIdentifier.type) {
      case 'CIVIL':
      {
        this.requestSubscription =
            this.civilSearchService.findByCaseIdentifier(caseIdentifier)
              .subscribe(civilCase => {
                this.selectedCase = civilCase;
                this.caseViewService.setSelectedCase(this.selectedCase);
              },
                errorMessage => { this.errors.push(errorMessage); }
              );
          break;
      }
      case 'JUVENILE':
      {
        this.requestSubscription =
            this.juvenileSearchService.findByCaseIdentifier(caseIdentifier)
              .subscribe(juvenileCase => {
                this.selectedCase = juvenileCase;
                this.caseViewService.setSelectedCase(this.selectedCase);
              },
                errorMessage => { this.errors.push(errorMessage); }
              );
          break;
      }
      // case 'CRIMINAL':
      //   loadedCase = {caseInfo: 'criminal', TODO: 'implement me'};
      //   this.requestSubscription =
      //   this.caseNumberService.search(
      //     {'county': caseIdentifier.county, 'caseNumber': caseIdentifier.caseNumber},
      //     'CaseDetails'
      //     ).subscribe(criminalCaseList => {
      //         this.selectedCase = criminalCaseList[0];
      //         this.caseViewService.setSelectedCase(this.selectedCase);
      //        });
      //   break;

      default:
        this.selectedCase = null;
        this.caseViewService.setSelectedCase(this.selectedCase);
        break;
    }
  }

  isRequestInFlight(): boolean {
    return this.requestSubscription &&
           !this.requestSubscription.closed;
  }

  private cancelAnyOutstandingRequest() {
    if (this.requestSubscription) {
      this.requestSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/case-view.component.ts